import { SalesChannelCategoryGroupListPage } from "@/features/sales-channel-category-group/pages/SalesChannelCategoryGroupListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/sales-channel-category-group/")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["sales_channel_category_groups.view"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: SalesChannelCategoryGroupListPage,
});
